import { Star } from "@phosphor-icons/react";
import { BugPriority } from "shared/types/bug-report";
import { PickerItemProps } from "../../types";

export const BugPriorityItem = ({ item, isSelected, onSelect }: PickerItemProps<BugPriority>) => {
  const getPriorityColor = (priority: BugPriority) => {
    switch (priority) {
      case BugPriority.LOW:
        return "bg-green-100 text-green-700 border-green-300";
      case BugPriority.MEDIUM:
        return "bg-blue-100 text-blue-700 border-blue-300";
      case BugPriority.HIGH:
        return "bg-orange-100 text-orange-700 border-orange-300";
      case BugPriority.CRITICAL:
        return "bg-brick-primary/10 text-brick-primary border-brick-primary/30";
      default:
        return "bg-gray-100 text-gray-700 border-gray-300";
    }
  };

  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors hover:bg-brick-secondary-fine ${
        isSelected ? "bg-moss-primary/10 border border-moss-primary/30" : ""
      }`}
    >
      <div className="flex items-center gap-2">
        <Star className="h-4 w-4 text-neutral-secondary-mid" weight="duotone" />
        <div className={`px-2 py-1 rounded-md border text-xs font-medium ${getPriorityColor(item)}`}>
          {item}
        </div>
      </div>
    </button>
  );
};
